export { default as ArrowSmLeftOutlineIcon } from './ArrowSmLeftOutlineIcon';
